import './styles.scss';
import createElement from '../../utils/createElement';


class ScreenWrap {
    constructor(...children){
        this.html = {};
        this.html.wrap = <div class="screen-wrap"/>;
        children.forEach(child => {
            this.html.wrap.appendChild(child);
        });
        this.width = null;
        this.height = null;
        this.floatVal = null;
    }

    mountTo(mountNode){
        mountNode.appendChild(this.html.wrap);
    }

    size(height, width){
        this.html.wrap.style.height = height + 'px';
        this.html.wrap.style.width = width + 'px';
        this.width = width;
        this.height = height;

        if (this.floatVal === 'left'){
            this.html.wrap.style.left = `${(-1) * this.width}px`;
        }

        if (this.floatVal === 'right'){
            this.html.wrap.style.right = `${(-1) * this.width}px`;
        }
    }

    float(floatVal){

        if (floatVal === 'left'){
            this.floatVal = floatVal;
            this.html.wrap.style.position = 'absolute';
            if (this.width !== null){
                this.html.wrap.style.left = `${(-1) * this.width}px`;
            }
            this.html.wrap.style.right = '';
            return;
        }

        if (floatVal === 'right'){
            this.floatVal = floatVal;
            this.html.wrap.style.position = 'absolute';
            this.html.wrap.style.left = '';
            if (this.width !== null){
                this.html.wrap.style.right = `${(-1) * this.width}px`;
            }
            return;
        }

        this.floatVal = null;
        this.html.wrap.style.position = '';
        this.html.wrap.style.left = '';
        this.html.wrap.style.right = '';
    }
}


export default ScreenWrap;




// WEBPACK FOOTER //
// ./src/js/screens/ScreenWrap/index.js